export default "__VITE_ASSET__wFNR_yJU__"